import React from "react";
import "./about.css";

function About() {
  return (
    <div className="about">
      <div className="shop_header">
        <div
          className="container"
          style={{ fontSize: "20px", fontFamily: "-moz-initial" }}
        >
          <b>About</b>
          <br />
          <p style={{ paddingTop: "10px" }}>Home/About Us</p>
        </div>
      </div>

      <div className="container">
        <div className="about_txt">
          <h1 className="about_txt_head"> Summary</h1>

          <p className="about_txt_bdy">
            We are sure that you and your smartphone would be tired of the
            redundant case culture. FiveOTA is here to give you an alternative
            to this. How? Well, by <br /> selling premium tech accessories (some
            pretty cool stuff 😛 )
          </p>
        </div>
      </div>
      <br />
      <div className="container">
        <div className="about_txt">
          <h1 className="about_txt_head"> Our story</h1>

          <p className="about_txt_bdy">
            We started as young, ambitious people, looking for opportunities to
            start a venture. Then the whole project of fiveOTA and skin
            accessories caught our attention and we decided to start a skin
            culture. <br /> <br /> Smartphones are now almost like a primary
            necessity. We observed how owning a branded smartphone automatically
            created judgment. As they say, first impressions go a long way. So,
            we thought of wrapping up your smartphones with colours and textures
            no mobile company would offer. We wish to re-invent your device,
            help you get rid of the boring and redundant looks of your phone.
            FiveOTA skins and wraps will turn heads and create a great first
            impression about you that communicates how unique you are because
            communication is established from every aspect of your self,
            including your phones. <br /> <br /> Here at fiveOTA, we sell
            premium high-quality skins, with a precision cut you have not seen
            before, and that is not the only thing we are proud of. Our first
            ever skin customization is the thing that sets up apart from every
            other mobile accessory company. FiveOTA custom+ is our biggest USP,
            basically our identity.
          </p>
        </div>
      </div>
      <br />

      <div className="container">
        <div className="about_txt">
          <h1 className="about_txt_head"> Vision</h1>

          <p className="about_txt_bdy">
            iveOTA is an organization run by young individuals, with ideas that
            are fresh and unique. This organization brings youthful energy into
            its products and wishes to connect with the youth. At fiveOTA, we
            strongly believe in providing a platform to the youth, and in order
            to do so, we give opportunities to marketing gigs, photographers,
            models, and students to add value to our product in their own ways.
            Lastly, our vision is to start a skin culture with a human touch
            i.e. to understand our customers before selling them our products.
            We believe in lasting first impressions and are committed to
            creating that for our clients.
          </p>
        </div>
      </div>
      <br />

      <div className="container">
        <div className="about_txt">
          <h1 className="about_txt_head"> Strengh</h1>

          <p className="about_txt_bdy">
            ike any other company, we take great pride in our products. FiveOTA
            offers around 35 different skin materials to accommodate the choices
            of its wide range of audiences. Our skins have very high precision
            that fits your device perfectly. Other than the makeover our skin
            does to your phone (and your first impression), we pride in the fact
            that it is scratch, dust and fingerprint resistant. Our glue is like
            a perfect ex because removing the skin will leave behind no residue.
            <br />
            <br />
            It will almost be a crime if we don’t mention our custom + feature.
            The USP of our company lies in the fact that we wish to offer
            personalization to re-invent your devices in a way that resonates
            with WHO YOU ARE.
          </p>
        </div>
      </div>
      <br />
    </div>
  );
}

export default About;
